module.exports = __webpack_public_path__ + "img/Character_Xinyan_Thumb.0a548643.png";